import React, { Component } from 'react';
//import {connect} from 'react-redux';

import './../../../scss/App.scss';

//import { trackingWrapper } from '../../utils/analytics';

class StepsMap extends Component {

	constructor(props){
		super(props);

		this.state = {
			"step": this.props.step
		}

	}

	componentDidMount(){
		//this.animateIn();

		//window.sounds.introBg.play();

		/*
		let _this = this;

		setTimeout(() => {
			_this.props.handleIntroComplete();
		}, 3000);
		*/

	}

	componentWillReceiveProps(nextProps){
		if(nextProps.step !== this.state.step){
			this.setState({
				"step": nextProps.step
			});
		}
	}

	animateIn(){
		/*
		window.TweenMax.set(this.refs.logo, {transform:"translateX(-10%)", opacity:0});
		window.TweenMax.to(this.refs.logo, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.tagline, {transform:"translateX(-90%)", opacity:0});
		window.TweenMax.to(this.refs.tagline, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.crosswordBg, {opacity:0});
		window.TweenMax.to(this.refs.crosswordBg, 2, {ease:"linear", opacity:1});
		window.TweenMax.to(this.refs.crosswordBg, 20, {top:"-16vw"});

		let _this = this;
		setTimeout(() => {
			_this.aniamteOut();
			_this.props.handleIntroInComplete()
		}, 4000);
		*/
	}

	aniamteOut(){
		/*
		let _this = this;

		window.TweenMax.to(this.refs.crosswordBg, .2, {opacity:0});
		window.TweenMax.to(this.refs.host, .2, {opacity:0});
		window.TweenMax.to(this.refs.tuneIn, .3, {opacity:0});
		window.TweenMax.to(this.refs.bg, 1, {opacity:0, onComplete:function(){
			_this.props.handleIntroOutComplete();
		}});

		window.TweenMax.to(this.refs.logo, .4, {opacity:0});
		window.TweenMax.to(this.refs.logo, .5, {ease:"expo.in", transform:"translateX(-150%)"});

		window.TweenMax.to(this.refs.tagline, .4, {opacity:0});
		window.TweenMax.to(this.refs.tagline, .5, {ease:"expo.in", transform:"translateX(50%)"});
		*/
	}


	render() {

		let step1Active = "";
		let step2Active = "";
		let step3Active = "";

		if(this.state.step === 1){
			step1Active = " active";
		}

		if(this.state.step === 2){
			step1Active = " active";
			step2Active = " active";
		}

		if(this.state.step === 3){
			step1Active = " active";
			step2Active = " active";
			step3Active = " active";
		}

		return (
			<div id="steps-map">
				<div className={"step" + step1Active}>
					<div className="ro"></div>
					<div className="label">Step 1</div>
				</div>
				<div className={"step" + step2Active}>
					<div className="ro"></div>
					<div className="label">Step 2</div>
				</div>
				<div className={"step" + step3Active}>
					<div className="ro"></div>
					<div className="label">Step 3</div>
				</div>
			</div>
		);
	}
}

export default StepsMap;


// WEBPACK FOOTER //
// ./src/js/components/generator/StepsMap.js